import { type ButtonHTMLAttributes, forwardRef } from 'react'
import * as S from './styled'

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'id'> {
  id: string
  variant?: S.ButtonVariant
  mt?: number
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, variant = 'primary', mt, ...props }, ref) => (
    <S.StyledButton $variant={variant} $mt={mt} ref={ref} {...props}>
      {children}
    </S.StyledButton>
  ),
)
